import { render, staticRenderFns } from "./AdminBrandList.vue?vue&type=template&id=0370ce37&"
import script from "./AdminBrandList.vue?vue&type=script&lang=js&"
export * from "./AdminBrandList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports